const defaultState = () => ({
    type: '',
    items: []
});
export default defaultState;
